import { Single as SingleOrder } from './Single';

export default SingleOrder;
